var fw = [],
  fb = [];

(function($) {
  $.fn.drags = function(opt) {
    opt = $.extend({ handle: "", cursor: "pointer" }, opt);

    if (opt.handle === "") {
      var $el = this;
    } else {
      var $el = this.find(opt.handle);
    }

    return $el
      .css("cursor", opt.cursor)
      .on("mousedown", function(e) {
        if (opt.handle === "") {
          var $drag = $(this).addClass("draggable");
        } else {
          var $drag = $(this)
            .addClass("active-handle")
            .parent()
            .addClass("draggable");
        }
        var z_idx = $drag.css("z-index"),
          drg_w = $drag.outerWidth(),
          pos_x = $drag.offset().left + drg_w - e.pageX;

        $drag
          .css("z-index", 1000)
          .parents()
          .on("mousemove", function(e) {
            var $t = $(".section--before-after-active"),
              x = e.clientX,
              margin = $t.offset().left,
              i = $t.parents(".article-wrapper").index();
            $(".draggable")
              .offset({
                // left: e.pageX + pos_x - drg_w
                left: x - margin - 40
              })
              .on("mouseup", function() {
                $(this)
                  .removeClass("draggable")
                  .css("z-index", z_idx);
              });

            if (
              x - margin <= $t.width() &&
              $(".section--before-after--after").hasClass("draggable")
            )
              $t.find(".section--before-after-marker").width(x - margin);

            var percentage = (x - margin) / $t.width();
            if (!fw[i] && percentage > 0.8) {
              fw[i] = true;
              sendStats(
                "before-after",
                "view",
                $t.parents(".article-wrapper").data("id") +
                  " / " +
                  $t.data("id"),
                $t.find(".section--before-after-wraper img").attr("src")
              );
            }
            if (!fb[i] && percentage < 0.2) {
              fb[i] = true;
              sendStats(
                "before-after",
                "view",
                $t.parents(".article-wrapper").data("id") +
                  " / " +
                  $t.data("id"),
                $t.find(".section--before-after--before img").attr("src")
              );
            }
          });
        e.preventDefault(); // disable selection
      })
      .on("mouseup", function() {
        if (opt.handle === "") {
          $(this).removeClass("draggable");
        } else {
          $(this)
            .removeClass("active-handle")
            .parent()
            .removeClass("draggable");
        }
      });
  };
})(jQuery);

$(".section--before-after--after").drags();
